import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';
import { media } from '../ui-components';

import exit from '../assets/icons/exit.svg';

const propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  image: PropTypes.string,
  alt: PropTypes.string
};

const HighlightOverlay = props => {
  const { isOpen, onClose, image, alt } = props;

  return (
    <OverlayWrapper isOpen={isOpen} onClick={() => onClose()}>
      <ExitButton onClick={() => onClose()} src={exit} />
      <OverlayContainer>
        <Zoom>
          <ZoomableImage
            src={image}
            style={{ cursor: 'default' }}
            onClick={e => e.stopPropagation()}
            alt={alt || 'Highlighted Image'}
          />
        </Zoom>
      </OverlayContainer>
    </OverlayWrapper>
  );
};

HighlightOverlay.propTypes = propTypes;

const OverlayWrapper = styled.div`
  position: fixed;
  display: ${({ isOpen }) => (isOpen ? '' : 'none')};
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10000;
  cursor: zoom-out;
`;

const OverlayContainer = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: scroll;

  * {
    position: relative;
    margin: 5% auto;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    max-width: 90%;

    animation: zoom-in 0.25s;
    @keyframes zoom-in {
      0% {
        transform: scale(0, 0);
      }
      100% {
        transform: scale(1, 1);
      }
    }
  }
`;

const ExitButton = styled.img`
  position: absolute;
  top: 15px;
  right: 15px;
  width: 30px;
  height: 30px;
  background-color: #f9f9f9;
  border-radius: 50px;
  z-index: 10001;
  cursor: pointer;

  :hover {
    background-color: #e7e7e7;
  }
`;

const ZoomableImage = styled.img`
  width: 70%;

  @media only screen and (max-width: ${media.mediumTop}) {
    width: auto;
  }
`;

export default HighlightOverlay;
